/**
 * @lines98/client/lib/mode-thumb-preview — ЕДИНЫЙ рендер мини-доски-превью режима на
 * `lib/board-view` (ствол→ветки). Один источник для ОБЕИХ поверхностей: лобби «Играть»
 * (components/mode-card) И карточки режимов на главной (screens/start-screen).
 *
 * ЗАЧЕМ (owner-directive 2026-06-22): на главной превью переведено со статичных PNG на
 * ЖИВОЙ board-view (чётко на любом размере, не мылит при увеличении). Чтобы не дублировать
 * логику «как нарисовать превью режима», она вынесена сюда из mode-card.ts.
 *
 * Уровень подсказки (§2.1): predict → госты (3 следующих) + ниша; classic → ниша; blind →
 * голо. Сид фиксированный (`startState`, статика, никогда не зачётная партия → нет
 * anti-shadow). Счёт/ходы на превью скрыты CSS (components/mode-thumb.css).
 */

import { startState } from '@lines98/shared';
import type { NextBall } from '@lines98/shared/types/game';

import type { BoardViewHandle } from './board-view.js';
import type { HintLevel } from './mode-registry.js';

/**
 * Небольшой фиксированный сид для превью-миниатюр — репрезентативная детерминированная
 * раскладка (одинаковая на каждом рендере; НЕ дневной сид, нет anti-shadow — это статичное
 * превью `startState`, никогда не зачётная игра).
 */
export const MODE_THUMB_SEED = 0x10b98;

/**
 * Нарисовать стартовую раскладку миниатюры через общий board-view с учётом уровня
 * подсказки режима (§2.1). Счёт/ходы скрыты CSS (превью, не партия).
 */
export function renderModeThumbPreview(board: BoardViewHandle, level: HintLevel): void {
  const st = startState(MODE_THUMB_SEED);
  const showNiche = level === 'predict' || level === 'classic';
  const ghosts: readonly NextBall[] | undefined = level === 'predict' ? st.next : undefined;
  board.setScore(0);
  board.setMoves(0);
  board.renderNiche(st.next, showNiche);
  board.renderStaticGrid(st.grid, ghosts);
}
